import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/editStudentProfileRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';
function EditStudentDetails({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');
  const [name,setName]=useState('');
  const [error,setError]=useState('');
  const [oldName,setOldName]=useState('');
const[id,setId]=useState('');

  const handleGoBack = () => {
    navigate(`/`); 
  };



const handleRollnoChange = (e) => {
    setRollno(e.target.value);
    setName('');
    setError('');
    setOldName('');
    setId('');
  };

const setStudent=(student)=>
{
    if(student)
    {
    setName(student.name);
    setId(student._id);
    setOldName(student.name);
    }
    else{
setName('');
    setId('');
      setOldName('');
    setError("Student not found!");
    }
}

    
    async function handleSearch(e)
        {
          e.preventDefault();
          try{
            const response= await editapi.post('/findStudent',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
               setStudent(response.data.studentDetails);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/findStudent',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                           setStudent(response.data.studentDetails);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }
  
 async function handleSave(e)
        {
          e.preventDefault();
          try{
            const response= await editapi.post('/updateStudentName',{ rollno,id,name:name.toUpperCase()},{headers:{'Authorization':`Bearer ${accessToken}`}});    
               setStudent(response.data.studentDetails);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/updateStudentName',{ rollno,id,name:name.toUpperCase()},{headers:{'Authorization':`Bearer ${nat}`}});    
                           setStudent(response.data.studentDetails);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }


  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> EDIT STUDENT DETAILS</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex items-center justify-center mt-4 ">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>

        {id!='' && (<div className="flex flex-col justify-center items-center p-1 mt-2">
            <label>
                Name
            </label>
            <input
            value={name}
            onChange={(e)=>setName(e.target.value)}
             className="w-full border-b border-gray-300 outline-none focus:border-green-600 px-2 py-1"
            />
           <div className="w-full  p-1 flex justify-end mt-3">
  <button
    className={`bg-blue-500 text-xs text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all duration-300 
                hover:bg-blue-600 hover:scale-105 active:scale-95 
                ${oldName === name ? 'opacity-50 cursor-not-allowed' : ''}`}
    onClick={handleSave}
    disabled={oldName === name}
  >
    UPDATE
  </button>
</div>
        </div>)}
        <p>{error}</p>


      </div>
      </div>
    </main>
  );
}

export default EditStudentDetails;
